import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from '../../../../../../../../components/items-table/create-column-definition-builder';
import { ReadOnlyCurrencyColumn } from './read-only-currency-column';

import messages from '../../messages';

const totalColumnId = 'edit-total-column';

const Total = ({ value }) => <ReadOnlyCurrencyColumn currencyValue={value} />;

Total.propTypes = {
  value: PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.number,
  }).isRequired,
};

const totalColumnDefinition = createColumnDefinitionBuilder({
  header: <FormattedMessage {...messages.totalAmount} />,
  accessor: totalColumnId,
  cell: Total,
  width: 1.5,
});

export { totalColumnId, totalColumnDefinition };
